import * as React from 'react';
import { Helmet } from 'react-helmet-async';

import { useParams } from 'js/lib/useRouter';

const COURSERA_HOSTED_PROGRAM_TRACKER = 'https://www.coursera-apply.org/ping';

const PROGRAM_TO_TRACKER_MAP: Record<string, string> = {
  'emba-iitr': COURSERA_HOSTED_PROGRAM_TRACKER,
  'statistics-data-analytics-pgdip-isi': COURSERA_HOSTED_PROGRAM_TRACKER,
  'bachelor-of-science-computer-science-bits': COURSERA_HOSTED_PROGRAM_TRACKER,
  'bachelor-of-science-data-science-ai-iitguwahati': COURSERA_HOSTED_PROGRAM_TRACKER,
  'mba-business-analytics-jgu': COURSERA_HOSTED_PROGRAM_TRACKER,
  'ma-public-policy-jgu': COURSERA_HOSTED_PROGRAM_TRACKER,
  'ma-international-relations-security-strategy-jgu': COURSERA_HOSTED_PROGRAM_TRACKER,
  'pgdm-spjimr': COURSERA_HOSTED_PROGRAM_TRACKER,
  'meng-computer-engineering-dartmouth': 'https://apply.gs.dartmouth.edu/ping',
};

/**
 * Ping tracker is Slate's analytics service. It is used for degree attribution for when the application is hosted on Slate.
 * For more info see https://docs.google.com/document/d/1knAL8Px5XzC0aX3PvERkpJH15mnoFZCIGVANTwKbVKI.
 */
const PingTracker = () => {
  const { slug } = useParams();
  const trackerLink = slug ? PROGRAM_TO_TRACKER_MAP[slug] : undefined;

  if (!trackerLink) {
    return null;
  }

  return (
    <Helmet>
      <script async={true} src={trackerLink} />
    </Helmet>
  );
};

export default PingTracker;
